export default __webpack_public_path__ + "static/home-hero-1813c22833b5a2b0c3b65b680db96ebd.jpg";